import { useMutation } from 'react-relay';

import { checkTokenAndBankAccountMutation } from '@/__generated__/checkTokenAndBankAccountMutation.graphql';
import { checkTokenAndBankAccount } from '@/graphql/mutation/taxRefund/checkTokenAndBankAccount';

export const useCheckTokenAndBankAccount = () => {
  const [commit, isInFlight] = useMutation<checkTokenAndBankAccountMutation>(checkTokenAndBankAccount);

  return { commit, isInFlight };
};
